import { Component } from '@angular/core';
import { CourseSelectorComponent } from '../course-selector/course-selector.component';
import { CourseDetails } from '@lx/quote-tool/lite/shared/types';
import { DialogBasedSelector } from '@lx/quote-tool/lite/shared/ui/directives';
import { NgIf } from '@angular/common';
import { SelectorFieldContainerComponent, SidePanelComponent } from '@lx/quote-tool/lite/shared/ui/components';

@Component({
  standalone: true,
  selector: 'lx-course-selector-field',
  templateUrl: './course-selector-field.component.html',
  styleUrls: ['./course-selector-field.component.scss'],
  imports: [SidePanelComponent, SelectorFieldContainerComponent, CourseSelectorComponent, NgIf, SelectorFieldContainerComponent],
})
export class CourseSelectorFieldComponent extends DialogBasedSelector<CourseDetails> {}
